<template>
  <div
    class="wwf-form wwf-form-product"
    :class="[{ 'formValidation-shake': isShake }, className]"
  >
    <div class="wwf-loading-container" v-show="donation.isLoading">
      <div class="wwf-loading">
        <span></span>
      </div>
    </div>

    <form-wizard
      ref="wizard"
      shape="tab"
      @on-loading="setLoading"
      :start-index.sync="stepIndex"
      v-on:on-change="setFormStepState"
    >
      <h2 slot="title"></h2>
      <tab-content title="Choose" :before-change="() => validateStep('step1')">
        <Step1 ref="step1" :useNewCheckout="useNewCheckout" />
      </tab-content>
      <tab-content title="Details" :before-change="() => validateStep('step2')">
        <Step2
          ref="step2"
          :disabledGoogleAutocomplete="disabledGoogleAutocomplete"
          :thankYouUrl="thankYouUrl"
          :useNewCheckout="useNewCheckout"
          :isEarthHour="isEarthHour"
        />
      </tab-content>
      <tab-content title="Payment">
        <Step3
          :thankYouUrl="thankYouUrl"
          :useNewCheckout="useNewCheckout"
          :useProductThankYouUrl="useProductThankYouUrl"
        />
      </tab-content>
      <template slot="footer" slot-scope="props">
        <div class="form-buttons prev">
          <a
            href="#form-top"
            id="Previous"
            data-animation-duration="300"
            data-animation-easing="swing"
            data-smooth-scroll
            data-threshold="75"
            v-show="props.activeTabIndex == 1"
            @click="props.prevTab()"
            :style="props.fillButtonStyle"
            >Previous</a
          >
        </div>

        <div class="form-buttons next">
          <a
            href="#form-top"
            id="Next"
            :class="
              props.activeTabIndex != 0 && donation.payementType == 'wwf_paypal'
                ? 'paypal-button'
                : ''
            "
            data-animation-duration="300"
            data-animation-easing="swing"
            @click="props.nextTab()"
            data-smooth-scroll
            data-threshold="75"
            v-show="props.activeTabIndex != 2"
            :style="props.fillButtonStyle"
            >{{
              props.activeTabIndex == 0
                ? "Next"
                : donation.payementType == "wwf_paypal"
                ? "Pay with PayPal"
                : "Go to payment"
            }}</a
          >
        </div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

import {
  getParameterByName,
  getNameByDonationType,
  getNameByPaymentType,
  removeURLParameter,
} from "../../helpers";
import gtm from "../../utils/gtm";

import { mapState } from "vuex";

export default {
  name: "donation-listenner",
  components: {
    Step1, // Donation details (packages, handle, donation type, email, payement type)
    Step2, // Personnal details (name, address)
    Step3, // Payment
  },
  data() {
    return {
      isShake: false,
      stepIndex: 0,
      useNewCheckout: false,
      defaultDonationType: null,
    };
  },
  computed: mapState({
    donation: (state) => state.donation.donation,
    product: (state) => state.product.product,
  }),
  props: {
    disabledGoogleAutocomplete: {
      type: Boolean,
      default: false,
    },
    thankYouUrl: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: null,
    },
    isEarthHour: {
      type: Boolean,
      default: false,
    },
    useProductThankYouUrl: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    async product(newVal, oldVal) {
      // Pre-select the doallar handle and the package (rule: first item on the list)
      // As we only have Single and Regular, always set Single as the first option
      const defaultTypeExists =
        this.product.donationtypes.filter((e) => e === this.defaultDonationType)
          .length === 1;

      let defaultType = defaultTypeExists && this.defaultDonationType
        ? this.defaultDonationType
        : this.product.appealcodesetting.defaultdonationtype;

      this.product.donationtypes = this.product.donationtypes.sort((a, b) => {
        if (a === defaultType) {
          return -1;
        }
        if (b === defaultType) {
          return 1;
        }
        return 0;
      }); // Reverse alphabetical order

      this.donation.type = defaultType;
      const settings = this.product.donationsettings[defaultType];

      if (settings) {
        this.donation.campaignid = settings.campaignid;
        this.donation.fundid = settings.fundid;
      }

      if (this.product.producttype != "wildcard") {
        // Pre-select the package (rule: first item on the list)
        this.donation.packagecode =
          this.product.packages && this.product.packages.length > 0
            ? this.product.packages[0]
            : null;

        await this.$store.dispatch("getAllPackagesForProduct");
      }

      // Reset the doller handle
      this.donation.dollarhandle = null;

      this.setLoading(false);
    },
  },
  created: async function () {
    // LOADING
    this.setLoading(true);

    // FEATURE SWITCH - Get value for the switch for Custom Checkout
    try {
      this.useNewCheckout = await this.$store.dispatch(
        "getCustomCheckoutFeatureSwitch",
        this.productId
      );
    } catch (err) {
      this.useNewCheckout = false;
      console.error("Cannot get feature switch - Back to old checkout");
    }

    // PAYPAL CALL BACK
    try {
      // Check if there payment paypal pending to excecute
      const paymentid = getParameterByName("token");
      const payerid = getParameterByName("PayerID");
      if (payerid && paymentid) {
        console.log("excecutePayment found");
        const excecutePayment = await this.$store.dispatch("paymentPaypal", {
          payerid: payerid,
          paymentid: paymentid,
        });

        console.log("excecutePayment", excecutePayment);

        if (excecutePayment) {
          // Remove the query params from the URL
          let querylessUrl = removeURLParameter("token");
          querylessUrl = removeURLParameter("PayerID", querylessUrl);
          window.history.pushState({}, document.title, querylessUrl);

          this.thanksUser(excecutePayment);
        }
      }
    } catch (err) {
      console.log("Paypal execute error", err);
    }

    // QUERY PARAMS - Check if there are some query string in URL to prefill the form, Query from donate widget
    let q = getParameterByName("q");
    if (q) {
      let decodeq = "?" + window.atob(q);
      console.log("decodeq", decodeq);
      let amount = getParameterByName("amount", decodeq);
      let email = getParameterByName("email", decodeq);
      let firstname = getParameterByName("firstname", decodeq);
      let lastname = getParameterByName("lastname", decodeq);
      let salutation = getParameterByName("salutation", decodeq);
      let wildcardCode = getParameterByName("wildcardCode", decodeq);
      if (wildcardCode) {
        this.donation.packagecode = wildcardCode;
      }

      let dollarhandle = getParameterByName("dollarhandle", decodeq)
        ? getParameterByName("dollarhandle", decodeq).replace("$", "")
        : undefined;
      let dollarhandles = getParameterByName("dollarhandles", decodeq);
      if (dollarhandles) {
        // get dollarhandles from query params
        dollarhandles = dollarhandles.replace(/[^0-9\. ]+/g, "").split(" ");

        let newDollarHandles = [];
        dollarhandles.forEach((v, index) => {
          // Check if there is a product dollar handles index
          if (this.product.dollarhandles.Single[index]) {
            newDollarHandles.push({
              amount: v,
              img: this.product.dollarhandles.Single[index].img,
              text: this.product.dollarhandles.Single[index].text,
            });
          }
        });

        this.product.dollarhandles.Single = newDollarHandles;

        // todo: select Regular as default donation ?
      }

      this.donation.dollarhandle = dollarhandle;
      this.donation.amount = amount;
      this.donation.email = email;
      this.donation.firstname = firstname;
      this.donation.lastname = lastname;
      this.donation.title = salutation;
    }

    // Set default donation type by query param
    const dt = getParameterByName("dt");
    if (dt && (dt === "Single" || dt === "Regular")) {
      this.defaultDonationType = dt;
    }
    this.setLoading(false);
  },
  methods: {
    thanksUser(donation) {
      const donateThankYouUrl = donation.thankYouUrl;

      if (
        (this.useProductThankYouUrl && donateThankYouUrl) ||
        this.thankYouUrl
      ) {
        let query = `firstname=${donation.firstname}`;
        query += `&lastname=${donation.lastname}`;
        query += `&frequency=${donation.type}`;
        query += `&amount=${donation.amount}`;
        query += `&source=${document.URL}`;

        let params = "?q=" + window.btoa(query);
        const baseUrl =
          this.useProductThankYouUrl && donateThankYouUrl
            ? donateThankYouUrl
            : this.thankYouUrl;
        const url = baseUrl + params;

        // Send data to Google Tag Manager
        gtm.pushPurchase(
          donation.key,
          donation.productname,
          donation.productid,
          donation.producttype,
          getNameByDonationType(donation.type),
          donation.amount,
          donation.postcode,
          getNameByPaymentType("wwf_paypal"),
          function () {
            setTimeout(() => {
              window.open(url, "_self");
            }, 1000);
          }
        );
      } else {
        window.app.thankyou(
          donation.amount,
          donation.type,
          donation.key,
          donation.productname,
          donation.postcode,
          donation.firstname,
          donation.lastname,
          donation.producttype,
          donation.certificateurl,
          donation.productid,
          "wwf_paypal",
          donation.wildcard ? donation.wildcard.pdf : null
        );
      }
    },
    setFormStepState: function (previousStep, nextStep) {
      // When the user is going from the 1 to 0 step
      if (previousStep === 1 && nextStep === 0) {
        gtm.pushRemoveFromCart(
          this.product.productname,
          this.product.id,
          this.donation.amount,
          this.product.producttype,
          getNameByDonationType(this.donation.type)
        );
      }
      this.donation.formWizardCurrentStep = nextStep;
    },
    setLoading: function (value) {
      this.donation.isLoading = value;
    },
    validateStep: function (name) {
      return new Promise((resolve, reject) => {
        var refToValidate = this.$refs[name];
        var isValid = refToValidate
          .validate()
          .then((response) => {
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    reset: function () {
      this.$refs.wizard.changeTab(2, 0);
      this.$store.dispatch("resetDonation");

      // Pre-select the doallar handle and the package (rule: first item on the list)
      this.donation.type =
        this.product.donationtypes && this.product.donationtypes.length > 0
          ? this.product.donationtypes[0]
          : null;

      const settings = this.product.donationsettings[this.donation.type];
      if (settings) {
        this.donation.campaignid = settings.campaignid;
        this.donation.fundid = settings.fundid;
      }

      this.donation.packagecode =
        this.product.packages && this.product.packages.length > 0
          ? this.product.packages[0]
          : null;

      console.log("reset");
    },
    retry: function () {
      this.setLoading(true);
      this.$store
        .dispatch("retryDonation")
        .then((response) => {
          this.$refs.wizard.activateAll();
          this.setLoading(false);
        })
        .catch((error) => {
          console.error("saveDonation error", error);
        });
      console.log("retry");
    },
    disablesteps: function () {
      this.$refs.wizard.desActivateAll();
    },
  },
};
</script>

<style scoped>
.no-wrapper {
  padding: 0 !important;
  box-shadow: none !important;
}
</style>

<style scoped>
/* This is the wrapper of the form, outside of the vue component... */

/* Override of the default style for the forms */

#form-top .wwf-form-product.wwf-form {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.wwf-form-product.wwf-form input[type="text"],
.wwf-form-product.wwf-form input[type="tel"],
.wwf-form-product.wwf-form input[type="email"],
.wwf-form-product.wwf-form input[type="number"],
.wwf-form-product.wwf-form input[type="date"],
.wwf-form-product.wwf-form select,
.wwf-form-product.wwf-form textarea {
  background-color: rgba(0, 0, 0, 0.05);
  border: 0;
  border-radius: 7px;
  box-shadow: inset 0 0 0 1px rgba(220, 220, 220, 0);
  cursor: pointer;
  height: 45px;
  padding: 15px 10px 0px 10px;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 1em;
}

.wwf-form-product.wwf-form textarea {
  padding: 20px 10px 0px 10px;
  width: 100%;
  min-width: 100%;
}

.wwf-form-product.field-address-readonly input,
.wwf-form-product.field-address-readonly input:hover,
.wwf-form-product.field-address-readonly input:focus {
  background-color: transparent;
  cursor: default;
  pointer-events: none;
  user-select: none;
  box-shadow: inset 0 0 0 1px rgba(220, 220, 220, 1);
}

.wwf-form-product.wwf-form input[type="text"]:hover,
.wwf-form-product.wwf-form input[type="tel"]:hover,
.wwf-form-product.wwf-form input[type="email"]:hover,
.wwf-form-product.wwf-form input[type="number"]:hover,
.wwf-form-product.wwf-form input[type="date"]:hover,
.wwf-form-product.wwf-form select:hover,
.wwf-form-product.wwf-form textarea:hover {
  background-color: rgba(0, 0, 0, 0.08);
  border: 0;
  box-shadow: inset 0 0 0 1px rgba(165, 165, 165, 0);
}

.wwf-form-product.wwf-form input[type="text"]:focus,
.wwf-form-product.wwf-form input[type="tel"]:focus,
.wwf-form-product.wwf-form input[type="email"]:focus,
.wwf-form-product.wwf-form input[type="number"]:focus,
.wwf-form-product.wwf-form input[type="date"]:focus,
.wwf-form-product.wwf-form textarea:focus {
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  box-shadow: inset 0 0 0 2px var(--primaryColor);
  cursor: text;
}

.wwf-form-product.wwf-form input[type="text"]:focus:hover,
.wwf-form-product.wwf-form input[type="tel"]:focus:hover,
.wwf-form-product.wwf-form input[type="email"]:focus:hover,
.wwf-form-product.wwf-form input[type="number"]:focus:hover,
.wwf-form-product.wwf-form input[type="date"]:focus:hover,
.wwf-form-product.wwf-form select:focus:hover,
.wwf-form-product.wwf-form textarea:focus:hover {
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  box-shadow: inset 0 0 0 2px var(--primaryColor);
}

.wwf-form-productinput[type="date"],
.wwf-form-product.has-content input[type="date"] ~ label {
  color: var(--wwfWhite);
}

.wwf-form-product.has-content input[type="date"],
input[type="date"]:focus {
  color: var(--wwfGrey47);
}

.wwf-form-product.wwf-form ::-webkit-input-placeholder {
  color: transparent;
}

.wwf-form-product.wwf-form ::-moz-placeholder {
  color: transparent;
}

.wwf-form-product.wwf-form :-moz-placeholder {
  color: transparent;
}

.wwf-form-product.wwf-form ::-ms-input-placeholder {
  color: var(--wwfWhite);
}

.wwf-form-product :-ms-input-placeholder {
  color: var(--wwfWhite);
}

.wwf-form-product.wwf-form select {
  padding: 15px 0px 0px 10px;
}

.wwf-form-product.wwf-form select {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  display: inline-block;
  line-height: 1.5em;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-position: calc(100% - 43px) calc(50% - 7px),
    calc(100% - 12px) calc(50% - 7px);
  background-size: 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  background-image: linear-gradient(to right, #ccc, #ccc), var(--selectArrowUrl);
  background-size: 1px 1.5em, 20px;
}

/* PAYPAL */

.wwf-form-product .form-buttons.next a:before {
  content: "Pay with";
  position: absolute;
  opacity: 0;
  transform: translateY(-50%) translateX(-20px);
}

.wwf-form-product .form-buttons.next a:after {
  content: "";
  display: inline-block;
  width: 43%;
  height: 0;
  padding-top: 13%;
  background-image: url(https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/PayPal.png);
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  right: 0;
  top: 50%;
  position: absolute;
  opacity: 0;
  transform: translateY(-50%);
}

.wwf-form-product .form-buttons.next .paypal-button {
  background-color: var(--wwfYellowPaypal) !important;
  height: 50px;
  transition: opacity 0.3s;
  color: transparent !important;
}

.wwf-form-product .form-buttons.next .paypal-button:before {
  content: "Pay with";
  font-size: 13px;
  text-transform: none;
  color: var(--wwfGrey33);
  display: inline-block;
  vertical-align: middle;
  transition: font-size 0s 0s, opacity 0.3s 0.3s, transform 0.3s 0.3s;
  left: 12%;
  top: 50%;
  transform: translateY(-50%) translateX(0px);
  opacity: 1;
  line-height: 0;
}

.wwf-form-product .form-buttons.next .paypal-button:after {
  content: "";
  display: inline-block;
  width: 45%;
  height: 0;
  padding-top: 12.8%;
  background-image: url(https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/PayPal.png);
  background-size: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  right: 12%;
  opacity: 1;
  transition: right 0.3s 0.3s, opacity 0.3s 0.3s;
}

@media only screen and (max-width: 64em) {
  .wwf-form-product .form-buttons.next .paypal-button:after {
    width: 40%;
    padding-top: 12.8%;
    right: 10%;
  }

  .wwf-form-product .form-buttons.next .paypal-button {
    height: 40px;
  }
}

@media only screen and (max-width: 374px) {
  .wwf-form-product .form-buttons.next .paypal-button:before {
    content: "Pay with";
    font-size: 11px;
    text-transform: none;
    color: var(--wwfGrey33);
    display: inline-block;
    vertical-align: middle;
    transition: font-size 0s 0s, opacity 0.3s 0.3s, transform 0.3s 0.3s;
    left: 12%;
    top: 50%;
    transform: translateY(-50%) translateX(0px);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// DonationListenner.vue?374185f4